import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CreateStudent} from '@interfaces/requests/create-student';
import {Store} from '@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {User} from '@models/user';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StudentService {

  user: User;

  constructor(
    private httpClient: HttpClient,
    private authStore: Store<AuthReducer.AuthState>,
  ) {
    this.authStore.subscribe(
      (val) => {
        const auth = val.auth;
        if (auth && auth.user) {
          this.user = auth.user;
        }
      }
    );
  }

  getAll(page: number = 0, type: string = 'all', withoutMembers = false) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      let url = school_id + '/student/' +  `${type}`;
      if (page > 0) {
          url += '?page=' + page;
        if (withoutMembers) {
          url += '&withoutMembers=true';
        }
      } else {
        if (withoutMembers) {
          url += '?withoutMembers=true';
        }
      }
      return this.httpClient.get(url);
    }
    return new Observable();
  }
  getStudentsByStatusType(statusType: string) {
    const school_id = this.user.activeSchool;
    return this.httpClient.get(`${school_id}/student/status-type/${statusType}`);
  }

  getStudentExpiring() {
      const school_id = this.user.activeSchool;
      return this.httpClient.get(school_id + '/student/expiring');
  }

  getStudentForTrial() {
      const school_id = this.user.activeSchool;
      return this.httpClient.get(school_id + '/student/trial');
  }
  getInfoForSchool() {
    const school_id = this.user.activeSchool;
    return this.httpClient.get(school_id + '/student/');
  }
  getInfoForSchoolSplit(school_id: number, isForWidget: boolean = false) {
      if (!school_id && this.user.activeSchool) {
          school_id = this.user.activeSchool;
      }
      let url = school_id + '/student/bySchool';

      if (isForWidget) {
        url += `?widget=${isForWidget}`;
      }
      return this.httpClient.get(url);
  }
  getSchoolsStudents(school_id: number, page: number, programId = null, classId = null, selectedCurriculumId = null) {
    let url = 'student/school/' + school_id + '?page=' + page;
    if (programId) {
      url += '&program_id=' + programId;
    }
    if (classId) {
      url += '&class_id=' + classId;
    }
    if (classId) {
      url += '&curriculum_id=' + selectedCurriculumId;
    }
    return this.httpClient.get(url);
  }
  programsStudents(programsIds: number[], page: number, programId = null, classId = null, selectedCurriculumId = null) {
    if (programsIds && programsIds.length > 0) {
      let url = 'student/programsStudents?ids=' + programsIds.join(',') + '&page=' + page;
      if (programId) {
        url += '&program_id=' + programId;
      }
      if (classId) {
        url += '&class_id=' + classId;
      }
      if (selectedCurriculumId) {
        url += '&curriculum_id=' + selectedCurriculumId;
      }
      return this.httpClient.get(url);
    }
    return new Observable();
  }
  getProgramStudents(program_id) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.get(school_id + '/student/program/' + program_id);
    }
    return new Observable();
  }
  getClassStudents(class_id) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.get(school_id + '/student/class/' + class_id);
    }
    return new Observable();
  }
  getInvitedUsers() {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.get(school_id+'/student/invited');
    }
    return new Observable();
  }
  create(body: CreateStudent) {
      return this.httpClient.post('student', body);
  }

  getStudentStatisticBySchool(schoolId: number) {
    return this.httpClient.get(`${schoolId}/student/statistic`);
  }
}
